<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import ArrowLeft from "#/assets/iconsDynamic/ArrowLeft.vue";

import { useAuth } from "#/composables/useAuth";
import { useCardLibStore } from "#/index";
import { useCartStore } from "#/store/cart";
import { useMainStore } from "#/store/main";
import AnimNum from "#/ui/recountNumber/RecountNumber.vue";
import clearLocalStorage from "#/utils/clearLocalStorage";


const { t } = useTranslation();

const router = useRouter();
const route = useRoute();

const storeCart = useCartStore();
const storeMain = useMainStore();
const cardLibStore = useCardLibStore();
const auth = useAuth();
const { orderNumber, orderCompleted_lib, selectedOrderType } = storeToRefs(storeCart);

const { config_lib, cartProducts_lib } = storeToRefs(storeMain);
const { cashPaymentAmount } = storeToRefs(storeCart);

const handleClick = () => {
	storeCart.isAdultConfirmed = false;
	cartProducts_lib.value = [];
	orderCompleted_lib.value = null;
	selectedOrderType.value = null;
	storeCart.clearCard();
  storeCart.fullReset?.();
	router.replace(`/${route.params.orgId}`);
};

const goToPreloader = () => {
	clearLocalStorage(["cart"]);
	auth.clear();
	cardLibStore.is_startPage = true;
	storeMain.isOrderTypeSubmited = false;
	handleClick();
};
</script>

<template>
  <div class="cash_success_page">
    <div class="header">
      <div>
        <ArrowLeft class="cash_back_btn" @click="handleClick" />
      </div>
      <h1 class="title">{{ t('cart-complete.cash.title') }}</h1>
    </div>
    <div class="content">
      <div class="cash_container">
        <div class="cash_circle">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" aria-hidden="true">
            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
      </div>
      <h2 class="cash_main_text">
        {{ t('cart-complete.cash.order-sent') }}
      </h2>
      <p class="subtitle">{{ t('cart-complete.cash.instruction') }}</p>
      <div class="cash_order_box">
        <p class="cash_order_label">{{ t('cart-complete.order-number') }}</p>
        <p class="cash_order_number">{{ orderNumber || '000' }}</p>
      </div>
      <div class="cash_amount_box">
        <p>{{ t('cart-complete.paymet-text') }}</p>
        <p class="cash_amount_value">
          <AnimNum :price="Math.abs(cashPaymentAmount ?? 0)" :symbol="config_lib.currency_symbol" />
        </p>
      </div>
      <button class="btn_primary" type="button" @click="goToPreloader">
        {{ t('cart-complete.cash.ready') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @use './completeCash.scss'
</style>